export const BUTTON_STATES =
  ':not(:disabled):not(.ant-btn-disabled):is(:hover, :active)';
